import { Component, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { RouteAuthorizedPoint } from 'src/app/core/interfaces/route-authorized-point';
import { RoutePointType } from 'src/app/core/interfaces/route-point-type';
import { DateManager } from 'src/app/core/managers/date.manager';
import { PlanningRoutesMessages } from 'src/app/core/messages/planning-routes-messages.enum';
import { AuthService } from 'src/app/core/services/authentication.service';
import { PlanningRouteService } from 'src/app/core/services/planning-route.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { RoutesMapComponent } from '../../routes-map/routes-map.component';
import { Patterns } from 'src/app/core/resources/patterns';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { StandardMapComponent } from 'src/app/shared/standard-map/standard-map.component';
import { Global } from 'src/app/core/resources/global';
declare var google: any;
@Component({
  selector: 'app-authorized-sites-form',
  templateUrl: './authorized-sites-form.component.html',
  styleUrls: ['./authorized-sites-form.component.scss']
})
export class AuthorizedSitesFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(StandardMapComponent) standardMap: StandardMapComponent;
  types: RoutePointType[] = [];
  pointId: string;
  form: FormGroup = new FormGroup({
    cityId: new FormControl('', [Validators.required]),
    cityName: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required, Validators.minLength(8)]),
    phone: new FormControl('', Validators.minLength(7)),
    address: new FormControl('', [Validators.required])
  });
  cityControl = new FormControl('', Validators.required);
  citySub: Subscription;
  cityOptions: OptionsAutocomplete = { title: "Ciudad", appearance: "outline" };
  validate = '';
  addressInputControl = new FormControl('', [Validators.required]);
  addressSubscription: Subscription;
  addressInitialValue: string = '';
  private addressData: { address: string, location: google.maps.LatLngLiteral };
  keyMarker: string = 'authorizedPoint';
  mapOptions: OptionsAutocomplete = {
    keyMarkerListener: this.keyMarker,
    initialClickMap: true,
    clickMapIcon: this.global.pathMarkerOrigin,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      type?: string
      site?: RouteAuthorizedPoint
    },
    public dialogRef: MatDialogRef<AuthorizedSitesFormComponent>,
    private planningRouteService: PlanningRouteService,
    private snackbarService: SnackBarService,
    private authService: AuthService,
    private patterns: Patterns,
    public utils: Utils,
    public spinner: NgxSpinnerService,
    public global: Global
  ) {
    if (this.data) {
      if (this.data.site) {
        this.form.get('cityId').setValue(this.data.site.city.id);
        this.form.get('cityName').setValue(this.data.site.city.name);
        this.cityOptions['initialValue'] = this.data.site.city.name;
        this.cityOptions = { ...this.cityOptions };
        this.form.get('type').setValue(this.data.site.details.pointType.id);
        this.form.get('name').setValue(this.data.site.details.name);
        this.form.get('phone').setValue(this.data.site.details.contactPhone);
        this.addressInputControl.setValue({
          address: this.data.site.address,
          location: this.data.site.location
        });
        this.addressInitialValue = this.data.site.address;
        this.addressData = {
          address: this.data.site.address,
          location: this.data.site.location
        };
        this.form.get('address').setValue({
          address: this.data.site.address,
          location: this.data.site.location
        });
        this.pointId = this.data.site.id;
      }
      if (this.data.type) this.form.get('type').setValue(this.data.type);
    }

  }

  ngOnInit() {
    this.requestForPointTypes();
    this.setSubscriptions();
  }

  private requestForPointTypes() {
    this.planningRouteService
      .getPointTypes()
      .subscribe(
        (types: RoutePointType[]) => {
          if (types && types.length) this.types = types;
        }
      )
  }

  setSubscriptions() {
    this.citySub = this.cityControl.valueChanges.subscribe(city => {
      this.form.get('cityId').setValue(city && city.id ? city.id : '');
      this.form.get('cityName').setValue(city && city.name ? city.name : '');
    });

    this.addressSubscription = this.addressInputControl.valueChanges.subscribe(value => {
      if (value && value.address && value.location) {
        this.addressData = value;
        this.form.get('address').setValue(value);

        if (this.standardMap) {
          this.standardMap.removeMarker(this.keyMarker);
          this.standardMap.createMarker(this.keyMarker, value.location.lat, value.location.lng, null, this.mapOptions.clickMapIcon);
          this.standardMap.setCenterMap(value.location.lat, value.location.lng, 16);
        }
      } else {
        this.addressData = null;
        this.form.get('address').setValue(null);
        if (this.standardMap) {
          this.standardMap.removeMarker(this.keyMarker);
        }
      }
    });
  }


  async onClickMap($event: any) {
    let lat = $event.latLng.lat();
    let lng = $event.latLng.lng();
    let address = await this.transformCoordinatesToAddress(lat, lng);
    let location = { lat: lat, lng: lng };

    if (address && location) {
      this.addressData = { address, location };
      this.addressInitialValue = address;
      this.addressInputControl.setValue({ address, location });
      this.form.get('address').setValue({ address, location });
    } else {
      this.snackbarService.openSnackBar('No se pudo obtener una dirección válida para el punto seleccionado.', undefined, 'alert');
      this.addressInputControl.setValue(null);
      this.addressData = null;
      this.form.get('address').setValue(null);
      if (this.standardMap) {
        this.standardMap.removeMarker(this.keyMarker);
      }
    }
  }

  async transformCoordinatesToAddress(lat: number, lng: number): Promise<string> {
    let geocoderService = new google.maps.Geocoder;
    let latlng = { lat: lat, lng: lng };
    let address = '';
    this.spinner.show();
    await new Promise<void>(resolve => {
      geocoderService.geocode({ 'location': latlng }, (results: any[], status: any) => {
        if (status === 'OK' && results.length) {
          this.spinner.hide();
          address = results[0].formatted_address;
        } else {
          this.spinner.hide();
          this.snackbarService.openSnackBar('No se pudo obtener la dirección para la ubicación seleccionada.', undefined, 'error');
        }
        resolve();
      });
    });
    return address;
  }


  ngAfterViewInit() {
    if (this.data && this.data.site && this.data.site.location && this.standardMap) {
      this.standardMap.setCenterMap(this.data.site.location.lat, this.data.site.location.lng, 16);
      this.standardMap.createMarker(this.keyMarker, this.data.site.location.lat, this.data.site.location.lng, null, this.mapOptions.clickMapIcon);
    }
  }

  create() {
    this.form.markAllAsTouched();
    this.validate = 'touched';
    if (this.addressInputControl.invalid) {
      this.snackbarService.openSnackBar(this.utils.giveMessageError('MANDATORY_FIELD', 'dirección'), undefined, 'alert');
      return;
    }

    if (this.form.invalid) {
      if (this.utils.errorMessagesCustomized(this.form.get('type'), 'tipo de servicio')) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('cityName'), 'ciudad')) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('name'), 'nombre', 8)) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('phone'), 'teléfono', 7)) return;
      else this.snackbarService.openSnackBar(PlanningRoutesMessages.INCOMPLETE_FORM, undefined, "error");
      return;
    }

    if (!this.addressData || !this.addressData.address || !this.addressData.location) {
      this.snackbarService.openSnackBar('Por favor, selecciona una dirección válida en el mapa o el autocompletado.', undefined, 'alert');
      return;
    }

    const point: RouteAuthorizedPoint = {
      active: true,
      fingerprint: {
        userId: this.authService
          .getUserSession()
          .information.document,
        userName: this.authService.getUserSession().information.name,
        date: DateManager.dateToString(new Date()),
      },
      city: {
        id: this.form.get('cityId').value,
        name: this.form.get('cityName').value
      },
      details: {
        contactPhone: this.form.get('phone').value,
        name: this.form.get('name').value,
        pointType: this.form.get('type').value
      },
      location: this.addressData.location,
      address: this.addressData.address
    }

    this.spinner.show();

    if (this.pointId) {
      point.id = this.pointId;
      this.planningRouteService.updateAuthorizedPoint(point).subscribe(
        () => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(PlanningRoutesMessages.UPDATED_AUTHORIZED_POINT, undefined, "success");
          this.dialogRef.close({ state: true });
        },
        (error) => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(PlanningRoutesMessages.HTTP_ERROR, undefined, "error");
        }
      )
    } else {
      this.planningRouteService.createAuthorizedPoint(point).subscribe(
        () => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(PlanningRoutesMessages.CREATED_AUTHORIZED_POINT);
          this.dialogRef.close({ state: true });
        },
        (error) => {
          this.spinner.hide();
          this.snackbarService.openSnackBar(PlanningRoutesMessages.HTTP_ERROR, undefined, "error");
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.citySub) this.citySub.unsubscribe();
    if (this.addressSubscription) this.addressSubscription.unsubscribe();
  }
}
